import { AllSanitySchemaTypes, Slug } from "@/sanity/sanity.types";

export default function buildDocumentUrl(slug: Slug, documentType: AllSanitySchemaTypes["_type"]) {
    switch (documentType) {
        case "bygdekinoenNewsDocument":
            return `/artikkel/${slug.current}`;
        default:
            return undefined;
    }
}